import { BaseFetch } from "../main-model"
export default class SubjectTransModel extends BaseFetch {
  getSubjectTransBy = (data) =>
    this.authFetch({
      url: "subject-trans/getSubjectTransBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getSubjectTransById = (data) =>
    this.authFetch({
      url: "subject-trans/getSubjectTransById",
      method: "POST",
      body: JSON.stringify(data),
    })
  updateSubjectTransById = (data) =>
    this.authFetch({
      url: "subject-trans/updateSubjectTransById",
      method: "POST",
      body: JSON.stringify(data),
    })
  insertSubjectTrans = (data) =>
    this.authFetch({
      url: "subject-trans/insertSubjectTrans",
      method: "POST",
      body: JSON.stringify(data),
    })
  deleteSubjectTransById = (data) =>
    this.authFetch({
      url: "subject-trans/deleteSubjectTransById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
